module.exports = {"410481001":"垭口街道","410481002":"寺坡街道","410481003":"朱兰街道","410481004":"院岭街道","410481005":"矿建街道","410481006":"铁山街道","410481100":"尚店镇","410481101":"八台镇","410481102":"尹集镇","410481103":"枣林镇","410481202":"庙街乡","410481204":"武功乡","410481205":"杨庄乡","410481400":"红山街道筹备处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410481.json
// module id = 1434
// module chunks = 0